import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import _ from 'lodash/fp'

import * as authReducer from '../../reducers/auth'

import { validator } from './Common'
import TextField from '@material-ui/core/TextField'
import Collapse from '@material-ui/core/Collapse'
import { makeStyles } from '@material-ui/core/styles'
import Button from './AuthButton'
import FacebookLogin from './AuthButton/Facebook'
import GoogleLogin from './AuthButton/Google'
import AppleLogin from './AuthButton/Apple'
import { DGULogin, GolfisLogin } from './AuthButton/Golfbox'

import SplitContainer from '../../components/SplitContainer'
import colors from '@fe/ui/colors'
import SnackWhen from '@fe/ui/SnackWhen'

const useStyles = makeStyles(theme => ({
  textField: {
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}))

const Welcome = props => {
  const classes = useStyles()
  const [login, setLogin] = React.useState(false)
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [touched, setTouched] = React.useState({})

  const handleLogin = React.useCallback((e) => {
    e.preventDefault()
    props.doLogin({ email, password })
  }, [props.doLogin, email, password])

  const emailError = _.get('email', touched) && !validator.isEmail(email) && 'Email is invalid'
  const passwordError = _.get('password', touched) && _.isEmpty(password) && 'Password is empty'
  const disableLogin = !login || _.isEmpty(email) || _.isEmpty(password) || emailError || passwordError

  const loginRef = React.useRef()
  return (
    <SplitContainer>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <h1 style={{ fontSize: '2em', textTransform: 'uppercase', fontWeight: 'bold' }}>Welcome</h1>
        <Link to='/signup' style={{ width: '100%' }}>
          <Button buttonColor={colors.primaryDarkGreen}>New user with email</Button>
        </Link>
        <DGULogin />
        <GolfisLogin />
        <FacebookLogin />
        <GoogleLogin />
        <AppleLogin />
        <span style={{ fontSize: 16, margin: '16px 0' }}>
          Already have a user?
        </span>
        <Button
          style={{
            padding: '8px 20px',
            borderColor: login ? colors.lightGreen : colors.primaryDarkGreen,
            borderWidth: 2,
            textTransform: 'unset',
            fontWeight: 'normal'
          }}
          onClick={() => {
            setLogin(!login)
          }}
          variant='outlined'
          textColor={colors.primaryDarkGreen}
          fullWidth={false}
        >
          Log in with email
        </Button>

        <Collapse
          in={login}
          onEntered={() => {
            window.scrollTo({
              behavior: 'smooth',
              top: loginRef.current && loginRef.current.offsetTop
            })
          }}
        >
          <div>
            <form className='auth-form' onSubmit={handleLogin}>
              <TextField
                margin='dense'
                fullWidth
                type='text'
                label={emailError || 'Email'}
                value={email}
                className={classes.textField}
                onChange={(e) => {
                  setEmail(_.get('target.value', e))
                }}
                variant='outlined'
                error={props.loginError || emailError}
                onBlur={() => setTouched(_.set('email', true))}
              />

              <TextField
                margin='dense'
                fullWidth
                type='Password'
                label={passwordError || 'password'}
                value={password}
                className={classes.textField}
                onChange={(e) => {
                  setPassword(_.get('target.value', e))
                }}
                variant='outlined'
                error={props.loginError || passwordError}
                onBlur={() => setTouched(_.set('password', true))}
              />

              <Button
                type='submit'
                disabled={disableLogin || props.loginWaiting}
                buttonColor={(disableLogin || props.loginWaiting) ? colors.borderEvenMoreNeutral : colors.primaryDarkGreen}
              >
                Let's go
              </Button>

              <Button
                buttonColor={colors.lightOrange}
                onClick={() => {
                  props.history.push('/reset-password')
                }}
              >
                I forgot my password
              </Button>
              <div ref={loginRef} id='dont look at me, I am shame' />
            </form>
          </div>
        </Collapse>

        <SnackWhen selector={() => !_.isEmpty(props.loginError)} type='error'>
          Could not login
        </SnackWhen>

      </div>
    </SplitContainer>
  )
}

export default _.compose(
  connect(
    (s) => ({
      loginError: authReducer.selectors.error(s),
      loginWaiting: authReducer.selectors.isWaiting(s)
    }),
    (d) => ({
      doLogin: ({ email, password }) => d(authReducer.actions.loginRequest({ email, password }))
    })
  )
)(Welcome)
